import React, { useState, memo } from "react"
import { LiveScoresContainer } from "./LiveScoresStyles"
import LiveScoreHeader from "./liveScoreComponents/LiveScoreHeader"
import LiveScoresLiveColumn from "./liveScoreComponents/LiveScoresLiveColumn"
import LiveScoresPrevColumn from "./liveScoreComponents/LiveScorePrevColumn"

const LiveScores = ({ removeComponents, popup }: any) => {
  const [previousRounds, setPreviousRounds] = useState<boolean>(false)

  return (
    <>
      {!popup && (
        <LiveScoresContainer removeComponents={removeComponents} popup={popup}>
          <LiveScoreHeader
            previousRounds={previousRounds}
            setPreviousRounds={setPreviousRounds}
          />

          {previousRounds ? <LiveScoresPrevColumn /> : <LiveScoresLiveColumn />}
        </LiveScoresContainer>
      )}
    </>
  )
}

export default memo(LiveScores)
